/**
 * Created by saeed on 12/29/2016.
 */
export class CompanyVM {
  id:number;
  title:string;
  description:string;
  phoneNumber:string;
  activityType:string;
  webSiteUrl:string;
  keyUrl:string;
  settingId:number;
  agreementId:number;
  locationId:number;
  location:LocationVM;
  tags;
  agreement;
  setting;
  customSetting;
  category;
  companyMode:string;
  coverImage:any;
  imageUrl;
  hasActivePaymentGateway:boolean;

  constructor(title:string) {
    this.title = title;
    this.id = 0;
    this.description = 'no description';
  }
}
export class LocationVM {
  public  address:string;
  public  mapX:string;
  public  mapY:string;

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/CompanyVM.model.ts